const validationMessagesConfig = {
  requiredNotesSpecialty: 'Specialty is required',
  requiredDateOfService: 'Date of Service is required'
};

export default validationMessagesConfig;
